import settings from '@/data/constants';
import { QueryKey } from '@/data/query';
import { toast } from '@montugroup/design-system';
import type { apiV1Contract } from '@montugroup/pms-api-contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

type UpdateDischargeStatusParams = Zod.infer<typeof apiV1Contract.patient.updateDischargeStatus.body>;
export const useUpdateDischargePatientStatus = ({
  firstName,
  lastName,
  patientCode
}: {
  firstName?: string | null;
  lastName?: string | null;
  patientCode?: string | null;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: async (payload: UpdateDischargeStatusParams) => {
      const response = await axios.put(`${settings.url}/patient/updateDischargeStatus`, payload);
      return response.data;
    },
    mutationKey: [QueryKey.DischargePatient],
    onSuccess: () => {
      toast.success(`${firstName} ${lastName} - ${patientCode} discharged successfully`);
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.some((key) =>
            [QueryKey.GetPatientConcessionCard, QueryKey.GetPatientDetails, QueryKey.GetPatientAssessments].includes(
              key as QueryKey
            )
          )
      });
    },
    onError: () => {
      toast.error(`${firstName} ${lastName} - ${patientCode} discharge Failed`);
    }
  });

  return {
    updateDischargePatientStatus: mutateAsync,
    ...rest
  };
};
